import apiClient from '@/services/axios'

export async function put(venueSetupId, venueSection) {
  var response = await apiClient.put(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/venue-setups/' + venueSetupId + '/venue-sections/' + venueSection.id, venueSection);

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to put venue section.')
}
